<script>
  import ClickOut from '../../../../../../utils/directives/clickout'

  export default{
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      clicked: function (e) {
        console.log('prevented!')
        e.preventDefault()
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li :class="{ active: open }">
    <a v-click-out="hide" @click="toggle" class="auto">
      <span class="pull-right text-muted">
      <i class="fa fa-fw fa-angle-right text"></i>
      <i class="fa fa-fw fa-angle-down text-active"></i>
      </span>
      <!-- <i class="icon-screen-desktop icon "></i> -->
      <span>Policiais</span>
    </a>
    <ul class="nav nav-sub dk">
      <li class="nav-sub-header"><a><span class="text-muted teste">Polícia Civil</span></a></li>
      <!--<li><a><span>Configurações</span></a></li>-->
      <li>
        <router-link :to="{ name: 'config.patentes.list' }">
          <span>Patentes</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'config.tipos-policia.list' }">
          <span>Tipos de Polícia</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.policia.policial.list' }">
          <span>Policiais</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'policiacivil.policia.unidade-policial.list' }">
          <span>Unidades Policiais</span>
        </router-link>
      </li>
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// Policiais.vue?28aaa99e